import {anomaliesConstants} from './anomalies.constants.js';
import {authenticationConstants} from "../authentication/auth.constants";

const initialState = {
    anomalies: null,
    count: 0,
    loading: false,
    resolving: false,
    error: null
}

export function anomalies(state = initialState, action) {
    switch (action.type) {
        case anomaliesConstants.ANOMALIES_FETCH_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case anomaliesConstants.ANOMALIES_FETCH_SUCCESS:
            return {
                ...state,
                anomalies: action.anomalies,
                count: action.anomalies.length,
                loading: false,
                error: null
            };
        case anomaliesConstants.ANOMALIES_FETCH_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case anomaliesConstants.ANOMALIES_COUNT_SUCCESS:
            return {
                ...state,
                count: action.count
            };
        case anomaliesConstants.ANOMALIES_RESOLVE_REQUEST:
            return {
                ...state,
                resolving: true,
                error: null
            };
        case anomaliesConstants.ANOMALIES_RESOLVE_SUCCESS:
            return {
                ...state,
                // On retire l'anomalie traitée de la liste, sans refetch
                anomalies: (state.anomalies || []).filter(a => a.id !== action.id),
                count: Math.max(0, state.count - 1),
                resolving: false,
                error: null
            };
        case anomaliesConstants.ANOMALIES_RESOLVE_FAILURE:
            return {
                ...state,
                resolving: false,
                error: action.error
            };
        case anomaliesConstants.ANOMALIES_CLEAR:
            return {
                ...initialState
            };
        case authenticationConstants.LOGOUT:
            return {
                ...initialState
            };
        default:
            return state
    }
}
